<div class="bg-white">
  <header>
    <div class="relative bg-white">
        <app-navbar></app-navbar>
    </div>
  </header>
  <main id="main-content">
    <router-outlet></router-outlet>
  </main>
  <!-- Footer section -->
  <app-footer></app-footer>
</div>